import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { ApiResponse } from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

// 사이트 모터 리셋
export const useResetSiteMotor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.sites.resetMotor],
    mutationFn: async (siteId: string): Promise<void> => {
      await XHRAuthorizedClient.post<ApiResponse<void>>(
        ENDPOINTS.sites.resetMotor(siteId)
      );
    },
    onSuccess: () => {
      // 모터 상태 관련 쿼리들을 무효화하여 데이터 갱신
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('모터 리셋 오류:', error);
    },
  });
};
